import React from 'react';
import http from 'api/http';
import { componentAPI } from 'api/requests';

import Select from 'Components/Select';
import NotificationManager from 'dom-managers/notification';

export default class ComponentList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      types: [],
    };
  }


  componentDidMount() {
    http.get(componentAPI.categoriesWithTypes)
      .then(({data}) => {
        if (data.length > 1) data.unshift({name:'All', value:{}});
        if (!data.length) NotificationManager.error('note', 'Cannot generate a Components list report: there are no approved components.');
        this.setState({categories: data});
      })
  }

  handleCategorySelect = newChosenCategory => {
    let { categories, types } = this.state;

    const checkCategoty = category => {
      if (!category.checked && category.componentTypes) types.push(...category.componentTypes);
      if (types.length > 1 && types[0].componentTypeName !== 'All') types.unshift({ componentTypeName: 'All' });
      category.checked = true;
    };

    const unCheckCategory = category => {
      category.checked = false;
      if (category.componentTypes) {
        category.componentTypes.forEach(categoryType => {
          let storedTypeIndex = types.findIndex(storedType => storedType.id === categoryType.id);
          if (storedTypeIndex !== -1) types.splice(storedTypeIndex, 1);
          categoryType.checked = false;
          this.props.removeComponentTypeId(categoryType.id);
        });

        if ((types.length === 2 || types.length === 1) && types[0].componentTypeName === 'All') types.shift();
      }
    };

    const toggleCategory = category => {
      if (category.checked) {
        unCheckCategory(category);
      } else {
        checkCategoty(category);
      }
    };

    if (newChosenCategory.name === 'All') {
      if (newChosenCategory.checked) {
        newChosenCategory.checked = false;
        categories.forEach(category => {
          unCheckCategory(category);
        });
      } else {
        newChosenCategory.checked = true;
        categories.forEach(category => {
          checkCategoty(category);
        });
      }
    } else {
      toggleCategory(newChosenCategory);
    }

    this.setState({ categories, types });
  };

  handleTypeSelect = chosenType => {
    const { removeComponentTypeId, addComponentTypeId } = this.props;
    let { types } = this.state;

    const checkType = type => {
      type.checked = true;
      if (type.id) addComponentTypeId(type.id);
    };

    const uncheckType = type => {
      type.checked = false;
      removeComponentTypeId(type.id);
    };

    const toggleType = type => {
      if (type.checked) {
        uncheckType(type);
      } else {
        checkType(type);
      }
    };

    if (chosenType.componentTypeName === 'All') {
      if (chosenType.checked) {
        types.forEach(type => {
          uncheckType(type);
        });
      } else {
        types.forEach(type => {
          checkType(type);
        });
      }
    } else {
      toggleType(chosenType);
    }

    this.forceUpdate();
  };

  render() {
    const {inputErrors} = this.props;
    const {categories, types} = this.state;

    const selectedCategoriesAmount = categories.filter(category => category.checked).length;
    const selectedTypesAmount = types.filter(type => type.checked).length;

    return (
      <section className='report-filters-section'>
        <header>Component Category / Type</header>
        <Select
          selectionList={categories}
          mainWrapperClassName='_width_330 _height_90'
          inputClassName='_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20'
          dropDownClassName='_border_radius_bottom_left_10 _border_radius_bottom_right_10'
          checkBoxClassName='_top_12 _left_10'
          label='Component Category *'
          itemNameIndicator={'name'}
          multiSelect
          withCheckBoxes
          withoutSearch
          disabled={!categories.length}
          placeholder={selectedCategoriesAmount ? `${selectedCategoriesAmount} is selected` : 'None'}
          handleSelect={this.handleCategorySelect} />
        <Select
          selectionList={types}
          mainWrapperClassName='_width_330 _height_90'
          inputClassName='_border_radius_10 _height_40 _width_330 _margin_top_12 _margin_bottom_20'
          dropDownClassName='_border_radius_bottom_left_10 _border_radius_bottom_right_10'
          checkBoxClassName='_top_12 _left_10'
          label='Component Type *'
          itemNameIndicator='componentTypeName'
          multiSelect
          withCheckBoxes
          withoutSearch
          disabled={!types.length}
          placeholder={selectedTypesAmount ? `${selectedTypesAmount} is selected` : 'None'}
          error={inputErrors.selectedTypesList}
          handleSelect={this.handleTypeSelect} />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ReportScene/ComponentList/index.jsx